<div class='popular-doctor__container cursor-pointer fromMainPageClass' [ngClass]="{'fromMainPageClass': isFromMainPage}" routerLink="/eqimi/{{translateToEnglish(doctor.fullName.replace(' ', '-'))}}/{{doctor.doctorId}}{{doctor.clinic ? '/'+doctor.clinic.id : ''}}">
  <div class="position-relative">
    <img alt=''
         class='swiper-lazy'
         data-src="{{baseUrl + '/web/api/files/profile_pic/' + doctor.doctorId + '?size=s'}}" loading='lazy'>

    <div class='doctor-rating'>
      <mat-icon svgIcon='star'></mat-icon>
      <span>{{doctor.raiting}}</span>
    </div>
  </div>
  <div class='doctor-info__container'>
    <div class='doctor-info__name'>
      <span class='doctor-name'>{{doctor.fullName}}</span>
    </div>
    <div class="doctor-info__specialty">
      {{doctor.speciality[0].specialityName}}
    </div>
    <div class="doctor-info__specialty text-danger font-weight-bold">
      {{doctor?.clinic?.name}}
    </div>
    <div class="doctor-info__actions">
      <div class="doctor-info__actions-services">
        <div class="doctor-info__service">
          <div [inlineSVG]="'assets/card-icons/new/home_visit_card-only-home.svg'" class="svg-18"></div>
        </div>
        <div class="doctor-info__service">
          <div [inlineSVG]="'assets/card-icons/new/video_call_card-only-video.svg'" class="svg-21"></div>
        </div>
        <div class="doctor-info__service">
          <div [inlineSVG]="'assets/card-icons/new/audio-call-cart-only-audio.svg'" class="svg-18 fill"></div>
        </div>
      </div>
      <button matRipple>
        <mat-icon>
          keyboard_arrow_right
        </mat-icon>
      </button>
    </div>
  </div>
</div>
